export default __webpack_public_path__ + "static/media/img1.5648d430.jpg";